import '../styles.css'

interface NotDataDisplayProps {
    message?: string;
}

const NotDataDisplay = ({ message = 'No hay datos para el periodo seleccionado.' }: NotDataDisplayProps) => (
    <div className='container-not-data-map'>
        <div className='bg-system-light-10 mx-4 md:m-0'>
            <p className='text-tsmall md:text-tmedium text-system-light-40 p-4'>{message}</p>
        </div>
    </div>
);

export default NotDataDisplay;
